import { isNetworkError } from '@if/core/utils'
import type { IApplicationInsights } from '@microsoft/applicationinsights-web'

let appInsights: IApplicationInsights | null = null

export function setupTracking(ai: IApplicationInsights): void {
  appInsights = ai
}

export function reportErrorToConsole(error: unknown) {
  console.error(error)
}
export function reportErrorToServer(error: Error) {
  if (!isNetworkError(error)) {
    reportErrorToConsole(error)
    appInsights?.trackException({ error, severityLevel: 3 })
  }
}
